<mat-toolbar class="no-print" [class.nabel-admin]="isNabelAdmin">
  <button mat-button class="hamburger" (click)="hamburgerClick.emit()" [disabled]="disabledMenu">
    <span class="mat-button-wrapper">
      <mat-icon>dehaze</mat-icon>
    </span>
  </button>
  <span class="leading-space"></span>
  <span>{{isSmallWindow ? shortenTitle : title}}</span>
  <span class="fill-remaining-space"></span>
  <button mat-flat-button
          class="user-menu"
          (click)="resetPasswordModal()"
          [matMenuTriggerFor]="menu">
    <div *ngIf="name" fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="-20px">
      <span class="name">{{name}} 様</span>
      <span class="mail">{{mail}}</span>
    </div>
  </button>
</mat-toolbar>

<mat-menu #menu="matMenu">
<!--  <button mat-menu-item-->
<!--          *ngIf="!passwordInputShown"-->
<!--          (click)="alterNabelAdmin()"-->
<!--          style="color: darkred">-->
<!--    <mat-icon>{{isNabelAdmin ? 'remove_moderator' : 'verified_user'}}</mat-icon>-->
<!--    <span>{{isNabelAdmin ? 'ナベル権限を外す' : 'ナベル権限を追加'}}</span>-->
<!--  </button>-->

  <button mat-menu-item
          (click)="switchPasswordModalShown();$event.stopPropagation()">
    <mat-icon>lock_reset</mat-icon>
    <span>パスワードを変更する</span>
  </button>

  <form *ngIf="passwordInputShown"
        (click)="$event.stopPropagation()"
        (keydown.tab)="$event.stopPropagation()"
        #form='ngForm'
        class="password-form"
        fxLayout="column">
    <mat-form-field>
      <input matInput name="password" #password='ngModel' placeholder="パスワード（6文字以上）"
             [type]="!showPassword ? 'password' : 'text'"
             [pattern]="usableStringForPassword" minlength="6"
             [(ngModel)]="pass.password">
      <mat-label *ngIf="password.dirty&&password.errors?.['minlength']">6文字以上必要です</mat-label>
      <mat-label *ngIf="password.dirty&&password.errors?.['pattern']">
        {{commonService.unusableStringList(pass.password)}}は使用できません
      </mat-label>
      <button mat-icon-button
              matSuffix type="button"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="showPassword">
        <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field *ngIf="!passwordConfirmed()">
      <input matInput name="confirmpassword" #confirmpassword='ngModel' placeholder="確認用"
             [type]="!showPassword ? 'password' : 'text'"
             [pattern]="commonService.regexFy(pass.password)"
             [(ngModel)]="pass.confirmpassword">
      <mat-label *ngIf="confirmpassword.dirty&&confirmpassword.errors?.['pattern']">
        一致しません
      </mat-label>
      <button mat-icon-button
              matSuffix type="button"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="showPassword">
        <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
  </form>

  <div style="padding: 0 16px" fxLayout="column">
    <button mat-stroked-button
            *ngIf="passwordInputShown&&passwordConfirmed()"
            color="primary"
            (click)="updatePassword()">
      <mat-icon class="done">done</mat-icon>
      <span style="margin-left: 0.25em">送信</span>
    </button>
  </div>

  <button mat-menu-item
          *ngIf="!passwordInputShown"
          (click)="sessionService.logout();"
          onclick="location.reload()">
    <mat-icon>logout</mat-icon>
    <span>ログアウト</span>
  </button>
</mat-menu>
